import React, { useEffect, useState } from "react";

import { useParams } from 'react-router-dom';
import { useSelector,useDispatch } from "react-redux";
import { GetAppText } from "../../../utils";

import { ButtonComponent } from "../../components/ButtonComponent";
import { useNavigate } from 'react-router-dom';
import SvgComponent from "../../components/SvgComponent";
import { SeparatorComponent } from "../../components/Separator";
import { apiRoutes } from "../../../apis/routes";
import { getRequest } from "../../../apis/methods";
import { Loader } from "../../components/Loader";
import { NewsCardComponent, formatPublishedDate } from "../../components/NewsCardComponent";
import { Image_URL } from "../../../utils/BaseUrl";
import { modalHandler } from "../../../store/slices/modalSlice";
import { handleSuccess } from "../../components/Toast/toastHelper";
import { ToastContainer } from "react-toastify";

const News = () => {
 
const { id } = useParams();
const navigate = useNavigate();
const [loading,setLoading]=useState(false)
const[data,setData]=useState('')
const [storyloading,setStoryLoading]=useState(false)
const[storyData,setstoryData]=useState('')
const[otherData,setOtherData]=useState('')
const isOpen = useSelector((state) => state.openModel.value);
const dispatch = useDispatch();
        useEffect(()=>{
          fetchData()
          
        },[id])

        useEffect(()=>{
       
           if(isOpen?.type==="share"){
            handleSuccess(isOpen?.msg,language)
          }
       
        },[isOpen])
      

        // useEffect(()=>{
        //   otherStoriesData()
        // },[])
        const fetchData = async () => {
          setLoading(true)
          try {
            const response = await getRequest(`${apiRoutes.get_newsDetails}?link=${id}`); // Replace with your endpoint
      if(response.status==="success")
         { 
          setLoading(false)
          setData(response?.data?.new)
          setOtherData(response?.data?.similar_news)
          }
        else{
          setLoading(false)
        }
          } catch (error) {
            setLoading(false)
            console.error('Error fetching data:', error);
          }
        };



        const language = useSelector((state) => state.language.value);


          const handleProjectClick = (id) => {
         
            navigate(`/news/${id}`);
          };
          

          const handle_share=()=>{
            const currentURL = window.location.href;
         
          const fullLink=`${currentURL}`
              // Copy the link to the clipboard
              navigator.clipboard.writeText(fullLink).then(() => {
                dispatch(modalHandler({type:"share",msg:GetAppText("link")}));
                setTimeout(()=>{
                  dispatch(modalHandler(""));
                },100)
              });
          
          }
          
  return (
    <div className="site-container py-12">
      <div className="mx-auto w-full max-w-[960px] space-y-10">
      <ToastContainer/>
{      loading?    <div className="flex justify-center items-center h-[540px]">
      <Loader/>
      </div>:

      // Article: title, then a full-width 4:3 image, then the body directly
      // below it in the same column. Nothing sits beside the image.
      <article dir={language === "_ar" ? "rtl" : "ltr"} className="w-full">
        <div className="flex items-start justify-between gap-4">
          <h1 className="font-bold sm:text-F28 text-F22 leading-snug">
            {language === "_ar" ? data?.title_ar : data?.title}
          </h1>
          <div dir="ltr" className="shrink-0">
          <ButtonComponent
            onClick={()=>{handle_share()}}
            tooltip={GetAppText("link_share")}
            title={GetAppText("sharing")}
            svg={
              <SvgComponent
                name={"ShareSvg"}
                className={"w-4 h-4"}
                stroke={"black"}
                fill={"none"}
              />
            }
            styles={"!py-2 w-fit !px-3 !text-black !text-F16 shrink-0"}
            type="secondary_transparent"
          />
          </div>
        </div>

        <div className="mt-6 w-full aspect-[4/3] overflow-hidden rounded-lg bg-gray-100">
          {data?.image && (
            <img
              src={`${Image_URL}${data?.image}`}
              alt={language === "_ar" ? data?.title_ar : data?.title}
              decoding="async"
              fetchpriority="high"
              className="block w-full h-full object-cover object-center"
            />
          )}
        </div>

        {data?.created_at && formatPublishedDate(data.created_at, language) && (
          <time dateTime={data.created_at} className="mt-3 block text-F14 text-secondaryTextColor">
            {formatPublishedDate(data.created_at, language)}
          </time>
        )}

        <div
          className="news-article-body mt-6 w-full text-primary sm:text-F18 text-F16"
          dangerouslySetInnerHTML={{ __html: language === "_ar" ? data?.description_ar : data?.description }}
        />
      </article>
      }
<SeparatorComponent  />
<div  className="space-y-8" >

<h1 dir={language === "_ar" ? "rtl" : "ltr"} className="font-semibold text-primary sm:text-F30 text-F24">{GetAppText("Other_news")}</h1>

    <div dir={language === "_ar" ? "rtl" : "ltr"} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 items-stretch">
{/* {images&&images?.map((item)=>(
<img src={item?.image} className="rounded-lg" alt="logo"/>

))} */}
     { loading ?
         <div className="col-span-full flex h-[300px] w-full justify-center items-center">
         <Loader/>
         </div>
         : 
    
         otherData?.length>0? 
         
         otherData.map((item,index)=>
(

  <NewsCardComponent fluid onClick={()=>{handleProjectClick(item?.slug)}} key={index}  data={item}/>

))  
:
(!loading && <div className="col-span-full flex w-full h-[300px] justify-center text-F20 font-semibold items-center">
             {GetAppText("no_data")}
              </div>)}
</div>
</div>
      </div>
  </div>
  );
};

export default News;
